import type { Topic } from "services/cms/models";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import getPathByType from "utils/getPathByType";

export interface ResolvedTopic {
    codename?: string;
    name: string;
    url: string;
}

const topicResolver = (data: Topic): ResolvedTopic => {
    const { name, urlSlug } = data.elements;

    return {
        codename: data.system.codename,
        name: name.value,
        url: getPathByType({
            slug: urlSlug.value,
            type: data.system.type as
                | ContentTypeCodenames.PressReleaseTopic
                | ContentTypeCodenames.Topic,
        }),
    };
};

export default topicResolver;
